/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');
    
    app.directive('slider', ['$window', 'Utils', function ($window, Utils) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes, model) {
                var native = element[0];
                var options = {
                    speed: 1,
                    damping: 0.1,
                    overscrollDamping: 1.0,
                    thumbMinSize: 20,
                    continuousScrolling: true,
                    alwaysShowTracks: false
                };
                var scrollbar;                
                function Init() {
                    scrollbar = Scrollbar.init(native, options);
                    // var throttled = Utils.throttle(scrollbar.update, 250);
                    var scrollContent = native.querySelector('.scroll-content');
                    scope.$watch(scrollContent.offsetHeight, function (height) {
                        scrollbar.update();
                        // throttled();
                    });
                }
                setTimeout(Init, 100);
            }
        };
    }]);

    /* -------------------------------------------------- 
    Scrollto component
    -------------------------------------------------- */
    app.directive('scrollTo', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                function onClick() {
                    if ($(attributes.scrollTo).offset()) {
                        var top = $(attributes.scrollTo).offset().top;
                        $('body').animate({ scrollTop: top + 'px' });
                    }
                }
                element.on('click', onClick);
                scope.$on('destroy', function () {
                    element.off('click', onClick);
                });
            }
        }
    }]);

    /* -------------------------------------------------- 
    Menu fixed top
    -------------------------------------------------- */
    app.directive('fixedNav', ['$log', 'Utils', 'CONFIG', function ($log, Utils, CONFIG) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var native = element[0];
                var currentOffset = window.pageYOffset;
                function checkScroll() {
                    if (screen.width < CONFIG.mobileMenuMaxWidth) {
                        // mobile
                        if (window.pageYOffset > currentOffset && window.pageYOffset > 150) {
                            native.classList.add('active');
                        } else {
                            native.classList.remove('active');
                        }
                    } else {
                        // desktop
                        if (window.pageYOffset > currentOffset && window.pageYOffset > 150) {
                            native.classList.add('active');
                        } else {
                            native.classList.remove('active');
                        }
                        /*
                        var focusedTop = $(document.activeElement).offset().top;
                        focusedTop = focusedTop > 0 ? focusedTop : Infinity;
                        if (window.pageYOffset > 150 && (window.pageYOffset < (focusedTop - $(native).height()) || window.pageYOffset > (focusedTop + $(native).height()))) {
                            native.classList.add('active');
                        } else {
                            native.classList.remove('active');
                        }
                        */
                    }
                    currentOffset = window.pageYOffset;
                }
                var throttled = Utils.throttle(checkScroll, 200);                
                function addListeners() {
                    angular.element(window).on('scroll', throttled);
                }
                function removeListeners() {
                    angular.element(window).off('scroll', throttled);
                }
                addListeners();
                scope.$on('destroy', function () {
                    removeListeners();
                });
            }
        }
    }]);

    /* -------------------------------------------------- 
    Open mobile menu
    -------------------------------------------------- */
    app.directive('mobileMenuToggler', ['$log', function ($log) {
        return {
            restrict: 'C',
            link: function (scope, element, attributes) {
                scope.isOpen = false;
                element.on('click', function () {
                    document.querySelector('.main-nav-first').classList.toggle('show');
                });
            }
        }
    }]);

    /* -------------------------------------------------- 
    Scrollto component
    -------------------------------------------------- */
    app.directive('backToTop', [function () {
        return {
            restrict: 'C',
            link: function (scope, element, attributes) {
                function onClick() {
                    $('body').animate({ scrollTop: 0 + 'px' }, 500);
                }
                element.on('click', onClick);
            }
        }
    }]);

    /* -------------------------------------------------- 
    Menu Dropdown
    -------------------------------------------------- */
    app.directive('mainNav', ['$log', 'Utils', function ($log, Utils) {
        return {
            restrict: 'C',
            link: function (scope, element, attributes) {
                var native = element[0];
                var currentOffset = window.pageYOffset;
                function checkScrollDirection() {
                    if (window.pageYOffset > currentOffset && window.pageYOffset > 150) {
                        // Scrolling down
                        currentOffset = window.pageYOffset;
                        native.classList.add('mobile-hidden');
                    } else {
                        // Scrolling up
                        currentOffset = window.pageYOffset;
                        native.classList.remove('mobile-hidden');
                    }
                }
                var throttled = Utils.throttle(checkScrollDirection, 400);
                $(window).scroll(throttled);
            }
        }
    }]);

    /* -------------------------------------------------- 
    Menu Dropdown
    -------------------------------------------------- */
    app.directive('hasDropdown', ['$log', 'CONFIG', function ($log, CONFIG) {
        return {
            restrict: 'C',
            link: function (scope, element, attributes) {
                var native = element[0];
                var toggler = native.querySelector('a');
                var dropdown = native.querySelector('.dropdown');
                native.addEventListener('click', function () {                    
                    if (screen.width < CONFIG.mobileMenuMaxWidth) {
                        // Mobile
                        $(dropdown).stop().slideToggle();
                    } else {
                        // Desktop 
                        element.toggleClass('open');
                    }
                });
                toggler.addEventListener('blur', function () {
                    // Permette il click sulla voce interna
                    setTimeout(function () {
                        if (screen.width >= 768) {
                            native.classList.remove('open');
                        }
                    }, 500);
                });
            }
        }
    }]);

    /* -------------------------------------------------- 
    Hero slider HOME
    -------------------------------------------------- */
    app.directive('heroHomeWrapper', ['$log', 'Utils', function ($log, Utils) {
        return {
            restrict: 'C',
            link: function (scope, element, attributes) {
                var native = element[0];
                var currentOffset = native.scrollTop;
                var height = native.clientHeight;
                function checkHeroScroll(e) {
                    if (native.scrollTop > currentOffset) {
                        // Scrolling down
                        if (currentOffset === 0) {
                            $(native).animate({ scrollTop: height + 'px' }, 300);
                        }
                        currentOffset = native.scrollTop;
                    } else {
                        // Scrolling up
                        currentOffset = native.scrollTop;
                        $(native).animate({ scrollTop: 0 + 'px' }, 300);
                    }
                }
                var throttled = Utils.throttle(checkHeroScroll, 400);
                native.addEventListener('scroll', throttled);
            }
        }
    }]);

    /* -------------------------------------------------- 
    Menu Dropdown
    -------------------------------------------------- */
    /*
    app.directive('scrollbar', ['$log', function ($log) {
        var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
        var isMac = navigator.platform.toLowerCase().indexOf('mac') !== -1;
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        console.log('scrollbar', isAndroid, isMac, iOS);
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                if (isAndroid || isMac || iOS) {
                    return;
                } 
                angular.element(document).ready(function () {
                    Scrollbar.initAll();                    
                });
            }
        }
    }]);
    */

    /* -------------------------------------------------- 
    Swiper
    -------------------------------------------------- */
    app.directive('swiper', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var swiper = new Swiper(element, {
                    direction: 'horizontal',
                    effect: 'coverflow',
                    loop: true,
                    autoplay: 3000,
                    coverflow: {
                        rotate: 20,
                        stretch: 0,
                        depth: 400,
                        modifier: 1,
                        slideShadows: false
                    },
                    slidesPerView: 3,
                    // pagination: '.swiper-pagination',
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    // scrollbar: '.swiper-scrollbar',
                });
            },
        };
    }]);

}());